import React from 'react'
import { FaExternalLink } from 'react-icons/lib/fa'

const link = "https://youtube.com/live_dashboard"

const Facebook = props => {
    return <div className="help__Facebook">
        <h4>Setup Directions</h4>
        <ul>
            <li>Login to your YouTube account and go to your Live Streaming dashboard <strong><a target="_blank" href={link}>{link} <FaExternalLink/></a></strong></li>
            <li>In the <strong>Encoder Details</strong> section, copy the <strong>Server URL</strong> and <strong>Stream Key</strong> and paste them into the fields above</li>
            <li>Click <strong>Add Target to Event</strong> below</li>
        </ul>
    </div>
}

export default Facebook